module.exports = __webpack_public_path__ + "img/align-center.ff45369b.svg";